import { TicketResponse } from 'accesso-model-lib';
import { Address, Card, Email, Phone, ScheduledPayments } from '../api/responses/payment-portal-login';
import { ContractViewerDetails } from 'src/app/pages/account/contract-viewer/models/contract.models';

// If Bookings Only, will have name info
export interface Details {
	address?: Address;
	email?: Email[];
	phone?: Phone[];
	cToken?: string;
	first_name?: string;
	id?: string;
	index?: string;
	last_name?: string;
	name?: string;
	shipping_name?: string;
}

export interface HistoricPayment {
	MEM: HistoricPaymentItem[];
	amount: string;
	payment_id: string;
	payment_index: string;
	scheduled_date?: string;
	date?: string;
	settlement_date: string;
	status: string;
	color?: string;
	labelText?: string;
	isMembership: boolean;
}

export interface HistoricPaymentItem {
	cart_adjustment_amount: string;
	discover_discount_amount?: string;
	fee_amount: string;
	late_fee_amount: string;
	late_fee_is_refunded: string;
	refunded_amount: string;
	retail_amount: string;
	status: string;
	tax_amount: string;
	termination_fee: string;
	termination_payment_index: string;
	ticket_id: string;
}

export class User {
	isCancelled: boolean;
	currentPaymentType: string;
	orderNumber: string;
	cToken?: string;
	purchaseDate?: string;
	oToken?: string;
	cepayMerchantId?: string;
	details: Details[];
	cards: Card[];
	paymentHistory: HistoricPayment[];
	scheduledPayments: ScheduledPayments;
	tickets?: TicketResponse[];
	jwt?: string;
	merchantId?: string;
	paymentType?: string;
	supportSecondaryPayment?: string;
	parentEConsignmentMerchantId?: string;
	status?: string;
	isDelinquent: boolean;
	delinquentAmount: number;
	payoffAmount: number;
	canPayoff: boolean;
	packageType: string;
	incomingDateFormat: string;
	compulsoryEndDate?: Date;
	inCompulsoryPeriod?: boolean;
	remainingCompulsoryAmount?: number;
	membershipTicketIds: string[];
	contractViewerDetails?: ContractViewerDetails;
}
